import {store} from "../../redux/store";
import React, {ReactNode} from "react";
import {useAppSelector} from "../../redux/hooks";
import {deviceStore} from "../../redux/device/deviceStore";

/**
 * This is a hack. Although this method is not called anywhere, for some reason including the "store;" line prevents the following
 * error from occurring
 *
 * "Cannot access 'deviceReducer' before initialization"
 *
 * Should probably look deeper into this at some point. A feature has been created to do so: https://dev.azure.com/playgroundsessions/Playground/_workitems/edit/2354/
 */

function unusedMethod() {
  store;
}

interface IThemeProps {
  children: ReactNode;
}

const isWebPSupported = determineIfWebPIsSupported();

export default function Theme({children}: IThemeProps) {
  const webPClassName = isWebPSupported ? "webp" : "no-webp";
  const isDesktop = useAppSelector(deviceStore.getDeviceIsDesktop);
  const desktopClassName = isDesktop ? `desktop` : ``;
  const isMacDesktop = useAppSelector(deviceStore.getDeviceIsMacDesktop);
  const desktopMacClassName = isMacDesktop ? `mac-desktop` : ``;
  return (
    <div className={`${desktopClassName} ${desktopMacClassName} theme-classic ${webPClassName}`}>
      {children}
    </div>
  );
}

function determineIfWebPIsSupported() {
  const elem = document.createElement('canvas');
  if (elem.getContext && elem.getContext('2d')) {
    return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
  } else {
    return false;
  }
}
